import * as localStorageUtils from 'utils/service/localStorageUtils';
import { TockNotification, TockNotificationType } from 'state/orderNotifications';
import { core } from '@tock/coretypes';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

export function calendarUpdate(
  businessId: number,
  changeUpdate: dashboard.CalendarDayEntityUpdates
): BaseTockAction {
  return {
    type: AppConstants.ORDER_NOTIFICATIONS_CALENDAR_ENTITY_UPDATE,
    payload: changeUpdate,
    context: businessId,
  };
}

export function chitPrinted(purchaseId: number): BaseTockAction {
  return {
    type: AppConstants.AUTO_PRINT_CHITS_CHIT_PRINTED,
    payload: purchaseId,
  };
}

export function queueNewOrderNotification(purchase: core.PastPurchase): BaseTockAction {
  return {
    type: AppConstants.ORDER_NOTIFICATIONS_QUEUE_ALERT,
    payload: TockNotification.NewOrder(purchase),
  };
}

export function queueOrderReadyForPrepNotification(purchase: core.PastPurchase): BaseTockAction {
  return {
    type: AppConstants.ORDER_NOTIFICATIONS_QUEUE_ALERT,
    payload: TockNotification.OrderReadyForPrep(purchase),
  };
}

export function dismissNotificationAlert(
  notificationType: TockNotificationType,
  purchaseId: number
): BaseTockAction {
  return {
    type: AppConstants.ORDER_NOTIFICATIONS_DISMISS_ALERT,
    payload: { notificationType, purchaseId },
  };
}

export function soundPlayed(purchaseId: number, forCreation: boolean): BaseTockAction {
  return {
    type: AppConstants.ORDER_NOTIFICATIONS_SOUND_PLAYED,
    payload: { purchaseId, forCreation },
  };
}

export function setChitPrintingStatus(status: {
  message: string;
  healthy: boolean;
}): BaseTockAction {
  return {
    type: AppConstants.AUTO_PRINT_CHITS_STATUS,
    payload: status,
  };
}

export function setNotificationSoundsEnabled(enabled: boolean): BaseTockAction {
  return {
    type: AppConstants.ORDER_NOTIFICATION_SOUNDS_ENABLED,
    payload: enabled,
  };
}

export function toggleNotificationSounds(): BaseTockAction {
  const soundsCurrentlyEnabled = localStorageUtils.getNotificationSoundsEnabled();
  localStorageUtils.setNotificationSoundsEnabled(!soundsCurrentlyEnabled);
  return setNotificationSoundsEnabled(!soundsCurrentlyEnabled);
}
